import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell, CheckCheck } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const { data } = await api.get("/notifications");
    setItems(data.notifications || []);
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`);
    load();
  };

  return (
    <div className="pt-6">
      <div className="text-xs font-bold tracking-[0.22em] uppercase text-brand-primary">Notifications</div>
      <h1 className="mt-1 font-display text-4xl font-semibold text-brand-charcoal">What&rsquo;s new</h1>

      <div data-testid="notif-list" className="mt-6 space-y-2">
        {items.length === 0 && <div className="text-brand-slate text-sm">You&rsquo;re all caught up.</div>}
        {items.map((n) => (
          <div
            key={n.id}
            className={`rounded-2xl border p-4 flex items-start gap-3 shadow-soft ${n.read ? "bg-brand-ivory border-brand-line" : "bg-brand-sand border-brand-primary/30"}`}
          >
            <div className={`h-10 w-10 rounded-full flex items-center justify-center ${n.read ? "bg-brand-sand text-brand-slate" : "bg-brand-primary text-brand-ivory"}`}>
              <Bell size={16} />
            </div>
            <div className="flex-1">
              <div className="font-semibold text-brand-charcoal">{n.title}</div>
              <div className="text-sm text-brand-slate">{n.body}</div>
              <div className="text-xs text-brand-slate mt-1">{new Date(n.created_at).toLocaleString("en-IN")}</div>
            </div>
            {!n.read && (
              <button
                data-testid={`notif-read-${n.id}`}
                onClick={() => markRead(n.id)}
                className="h-9 w-9 rounded-full bg-brand-primary text-brand-ivory flex items-center justify-center active:scale-95"
              >
                <CheckCheck size={14} />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
